import { render, staticRenderFns } from "./vehicleDetailContentBox.vue?vue&type=template&id=d7b7795a"
import script from "./vehicleDetailContentBox.vue?vue&type=script&lang=js"
export * from "./vehicleDetailContentBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports